"use strict";
/**
 * @description 选取范围所有顶级(段落)节点
 * @author tonghan
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var dom_core_1 = __importDefault(require("../../utils/dom-core"));
// 构造函数
var SelectionRangeTopNodes = /** @class */ (function () {
    /**
     * 构造函数
     * @param editor
     */
    function SelectionRangeTopNodes(editor) {
        // 初始化属性
        this.editor = editor;
        this.$nodeList = [];
        this.$startElem = dom_core_1.default(editor.selection.getSelectionStartElem()).getNodeTop(this.editor);
        this.$endElem = dom_core_1.default(editor.selection.getSelectionEndElem()).getNodeTop(this.editor);
    }
    /**
     * 初始化
     */
    SelectionRangeTopNodes.prototype.init = function () {
        this.recordSelectionNodes(dom_core_1.default(this.$startElem));
    };
    /**
     * 添加 节点 到nodeList
     * @param $node 节点
     */
    SelectionRangeTopNodes.prototype.addNodeList = function ($node) {
        this.$nodeList.push(dom_core_1.default($node));
    };
    /**
     * 是否是 选区结束 节点
     * @param $node 节点
     */
    SelectionRangeTopNodes.prototype.isEndElem = function ($node) {
        var _a;
        return (_a = this.$endElem) === null || _a === void 0 ? void 0 : _a.equal($node);
    };
    /**
     * 获取当前节点的下一个兄弟节点
     * @param $node 节点
     */
    SelectionRangeTopNodes.prototype.getNextSibling = function ($node) {
        return dom_core_1.default($node.elems[0].nextSibling);
    };
    /**
     * 记录节点 - 从选区开始节点开始 一直到匹配到选区结束节点为止
     * @param $node 节点
     */
    SelectionRangeTopNodes.prototype.recordSelectionNodes = function ($node) {
        var $elem = $node.getNodeTop(this.editor);
        if ($elem.length > 0) {
            this.addNodeList($elem);
            if (!this.isEndElem($elem)) {
                this.recordSelectionNodes(this.getNextSibling($elem));
            }
        }
    };
    /**
     * 获取 选中节点列表
     */
    SelectionRangeTopNodes.prototype.getSelectionNodes = function () {
        return this.$nodeList;
    };
    return SelectionRangeTopNodes;
}());
/**
 * 导出
 */
exports.default = SelectionRangeTopNodes;
